import React, { Fragment } from "react";
import { Popover, Transition} from '@headlessui/react';
import { classNames } from "../../utils/style";

export const TextInputs = { INPUT: "input", TEXTAREA: "textarea" } as const;

export type ITextInput = typeof TextInputs[keyof typeof TextInputs];

type TextInputProps = {
	type: ITextInput;
	currentValue: string;
    onChange:  (event: any) => void;
	rows?: number;
	title: string;
};

const TextInput: React.FC<TextInputProps> = ({
	currentValue,
    onChange,
	type,
	rows,
	title,
}) => {
	const CustomTag = type as React.ElementType;
	const minRows = rows || 4;
	const show = currentValue !== undefined && currentValue.length > 0;

	return (
		<Popover className="relative my-4 ">
			<Transition
				as={Fragment}
				show={show}
				enter="transition ease-out duration-200"
				enterFrom="opacity-0 translate-y-1"
				enterTo="opacity-100 translate-y-0"
				leave="transition ease-out duration-150"
				leaveFrom="opacity-100 translate-y-0"
				leaveTo="opacity-0 translate-y-1"
			>
				<Popover.Panel
					className={classNames(
						"text-gray-200",
						"box-border absolute -top-5 left-2 h-5 px-1 text-sm "
					)}
				>
					{title}
				</Popover.Panel>
			</Transition>
			<div>
				{type === TextInputs.INPUT && rows === undefined ? (
					<CustomTag
						className={classNames(
                            "box-border h-12 focus:border-primary-500 ",
							"mb-2 py-2 px-4 w-full rounded-md placeholder:font-light border placeholder:text-gray-400 border-gray-400 focus:outline-none focus:border-2 hover:border-primary-500"
						)}
						type="text"
						placeholder={title}
                        onChange={onChange}
					/>
				) : (
					<CustomTag
						className={classNames( "box-border h-28 focus:border-primary-500 ",
							"py-2 px-4 w-full rounded-md resize-none placeholder:font-light border placeholder:text-gray-400 border-gray-400 focus:outline-none focus:border-2 hover:border-primary-500"
						)}
						placeholder={title}
						rows={minRows}
                        maxLength={70}
                        onChange={onChange}
					/>
				)}
				<Transition
					as={Fragment}
					enter="transition ease-out duration-200"
					enterFrom="opacity-0 translate-y-1"
					enterTo="opacity-100 translate-y-0"
					leave="transition ease-out duration-150"
					leaveFrom="opacity-100 translate-y-0"
					leaveTo="opacity-0 translate-y-1"
				>
					<Popover.Panel
						className={classNames(
							"invisible text-gray-400",
							"box-border absolute -bottom-1 left-2 h-5 px-1 text-sm "
						)}
					>
					</Popover.Panel>
				</Transition>
			</div>
		</Popover>
	);
};
export default TextInput;
